import { MESSAGE_CREATE_UPDATE_START } from 'app/modules/messages/constants';
import redactPaymentCard from 'infrastructure/sideEffects/redactors';

const ActionSideEffects = {
  //MESSAGE
  [MESSAGE_CREATE_UPDATE_START]: redactPaymentCard,
};

const redactionMiddleware = (actionSideEffects = ActionSideEffects) => store => {
  return next => action => {
    const { type, record } = action;
    const sideEffect = actionSideEffects[type];
    if (sideEffect) {
      // redaction side effects must return a new record (even if it is the same as passed in)
      action.record = sideEffect(record);
    }

    return next(action);
  };
};

export default redactionMiddleware;
